import { render, staticRenderFns } from "./InputFormField.vue?vue&type=template&id=6118d830&"
import script from "./InputFormField.vue?vue&type=script&lang=js&"
export * from "./InputFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports